// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__qddU2","file":"styles_file__U-Cwf"};